var html = document.documentElement;
var body = document.body;
//Lazy Load
var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
});
lazyLoadInstance.update();

//Mobile menu
var itBurger = document.querySelector('.it-burger');
itBurger.addEventListener('click', function() {
    body.classList.toggle("it-head-open");
});

// Search
    var searchButton = document.querySelectorAll('.v-search-button');
    var searchBox = document.querySelector('.v-search-box');
    var searchClose = document.getElementById('searchClose');
    var searchInput = document.getElementById('searchInput');
    var searchResult = document.getElementById('searchResults');

    if (typeof searchApi !== 'undefined' && searchApi != null && searchInput != null) {
        searchButton.forEach(function(sb) {
            sb.addEventListener('click', function(e) {
                e.preventDefault();
                searchBox.classList.add('v-search-box-visible');
                body.classList.add('v-search-opened');
                window.setTimeout(function() {
                    searchInput.focus();
                }, 200);
            })
        });
        var searchinGhost = new SearchinGhost({
            key: searchApi,
            version: 'v4',
            inputId: ['searchInput'],
            outputId: ['searchResults'],
            outputChildsType: 'div',
            limit: 10,
            postsFields: ['title', 'url', 'excerpt', 'custom_excerpt', 'published_at'],
            postsExtraFields: ['tags'],
            template: function(post) {
                var o = '';
                o += '<a href="' + post.url + '">';
                o += '<h3 class="v-search-title"><span>' + post.title + '</span></h3> <div class="v-search-meta">';
                o += '<time>' + post.published_at + '</time></div></a>';
                return o;
            },
            onSearchEnd: function(posts) {
                if (searchResult.scrollHeight > searchResult.offsetHeight) {
                    searchResult.style.paddingRight = "8px";
                } else {
                    searchResult.style.paddingRight = "0px";
                }
            }
        });
        document.addEventListener('keyup', function(e) {
            if (e.keyCode == 27 && searchBox.classList.contains('v-search-box-visible') && body.classList.contains('v-search-opened')) {
                closeSearch();
            }
        });
        searchInput.addEventListener('keyup', function(e) {
            if (e.keyCode == 27) {
                closeSearch();
            }
        });
        searchClose.addEventListener('keyup', function(e) {
            if (e.keyCode == 13) {
                closeSearch();
            }
        });
        searchClose.addEventListener('keyup', function(e) {
            if (e.keyCode == 13) {
                closeSearch();
            }
        });
        searchBox.onclick = closeSearch;
        searchClose.onclick = closeSearch;

        function closeSearch(e) {

            if (e !== undefined && e.target !== e.currentTarget) {
                return;
            }
            searchBox.classList.toggle('v-search-box-visible');
            body.classList.toggle('v-search-opened');
            searchInput.value = '';
            searchResult.innerHTML = '';
        }
    }
//DarkMode
    var darkLight = document.querySelector('.dark-light');
    darkLight.addEventListener('click', function(){
    if(html.getAttribute('data-theme') === 'dark'){
        html.setAttribute('data-theme', 'light')
        localStorage.setItem('selected-theme', 'light');
    }else{
        html.setAttribute('data-theme', 'dark')
        localStorage.setItem('selected-theme', 'dark');
    }
    });
